import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  PoolId
} from './poolSlice'

import {GetAllPoolsState, GetAllUserPools, GetDepositStat, GetPoolState} from "@/context/UserPoolsContext.tsx";
import {CurrentMonthUtc} from "@/common/types/api/other.types.api.ts";

export const loadData = createAsyncThunk(
  'pool/loadData',
  async (
    {
      currentMonthUtc,
      address,
      getDepositStat,
      getPoolState
    }: {
      currentMonthUtc: CurrentMonthUtc
      address: string | undefined
      getDepositStat: GetDepositStat
      getPoolState: GetPoolState
    },
    {rejectWithValue}
  ) => {

    try {
      const [poolData, userData] = await Promise.all([
        getPoolState(1, currentMonthUtc.year, currentMonthUtc.month),
        address && currentMonthUtc ? getDepositStat(1, currentMonthUtc.year, currentMonthUtc.month, address) : Promise.resolve(null)
      ])

      return {poolData, userData}
    } catch (error) {
      console.error('Error loadData', error)
      return rejectWithValue('Ошибка загрузки пула или пользователя')
    }
  }
)

export const loadAllData = createAsyncThunk(
  'pool/loadAllData',
  async (
    {
      currentMonthUtc,
      address,
      getAllPoolsState, getAllUserPools
    }: {
      currentMonthUtc: CurrentMonthUtc | undefined
      address: string | undefined
      getAllPoolsState: GetAllPoolsState
      getAllUserPools: GetAllUserPools
    },
    {rejectWithValue}
  ) => {

    try {
      const [poolData, userData, poolId, addr] = await Promise.all([
        getAllPoolsState(),
        address ? getAllUserPools(address) : Promise.resolve(null),
        currentMonthUtc ? Promise.resolve({
          year: currentMonthUtc.year,
          month: currentMonthUtc.month
        } as PoolId) : Promise.resolve(null),
        address ? Promise.resolve(address as string) : Promise.resolve(null),
      ])

      return {poolData, userData, poolId, addr}
    } catch (error) {
      console.error('Error loadAllData',error)
      return rejectWithValue('Ошибка загрузки пула или пользователя')
    }
  }
)